const jQ = jQuery.noConflict();

function cfFunc() {
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        jQ('.newsletter-wrapper').remove();
        jQ('.newsletter-wrapper-success').show();
        jQ('.newsletter-wrapper-success').parents('.page-popup-content').find('.newsletter-popup-close').remove();
    }, false );
}

export default cfFunc;
